<mat-card>
  <mat-card-header>
    <mat-card-title>
      {{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE.LABEL' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      {{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.DESCRIPTION' | translate }}
    </p>
    <div *ngFor="let row of data" class="row mt-[16px]">
      <h5 class="flex items-center gap-[6px] mb-[8px]">
        <vi-icon [name]="row.icon" [size]="20"></vi-icon>
        {{ row.header | translate }}
      </h5>
      <p>{{ row.text | translate }}</p>
    </div>
  </mat-card-content>
  <mat-card-actions class="button-wrapper">
    <button mat-stroked-button mat-dialog-close>
      <span>
        {{ 'GENERAL.BUTTON.CLOSE' | translate }}
      </span>
      <mat-icon iconPositionEnd>close</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
